import * as React from 'react';
import {useState} from 'react';
import {HttpError, useDataProvider, useNotify, useRecordContext, useRefresh} from 'react-admin';
import {CircularProgress, MenuItem, Select} from '@mui/material';
import {USER_STATUS_CHOICES, UserStatus} from "../../constants/user-status";


export const StatusQuickEdit: React.FC = () => {
  const record = useRecordContext<{status: UserStatus, id: string}>();
  const notify = useNotify();
  const refresh = useRefresh();
  const dataProvider = useDataProvider();
  const [isLoading, setIsLoading] = useState(false)

  if (!record) return null;

  const handleChange = (value: UserStatus) => {
    if(isLoading) return
    setIsLoading(true)
    dataProvider
      .customMethod(`/admin/users/${record.id}/status`, {
        method: 'PUT',
        body: JSON.stringify({ status: value }),
      })
      .then(() => { notify('Status updated', { type: 'info' }); refresh(); })
      .catch((e: HttpError) => { notify(e.message || 'Update failed', { type: 'warning' }); })
      .finally(() => setIsLoading(false));
  };

  return (
    <Select
      size="small"
      value={record.status ?? ''}
      onChange={(e) => handleChange(e.target.value)}
      disabled={isLoading}
      displayEmpty
    >
      {isLoading && (
        <MenuItem value={record.status}>
          <CircularProgress size={16} style={{ marginRight: 8 }} />
          {record.status}
        </MenuItem>
      )}
      {!isLoading &&
        USER_STATUS_CHOICES.map(s => (
          <MenuItem key={s.id} value={s.id}>
            {s.name}
          </MenuItem>
        ))}
    </Select>
  );
};
